import { render, staticRenderFns } from "./copyrightDetails.vue?vue&type=template&id=5963f829&scoped=true&"
import script from "./copyrightDetails.vue?vue&type=script&lang=js&"
export * from "./copyrightDetails.vue?vue&type=script&lang=js&"
import style0 from "./copyrightDetails.vue?vue&type=style&index=0&id=5963f829&prod&lang=less&"
import style1 from "./copyrightDetails.vue?vue&type=style&index=1&id=5963f829&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5963f829",
  null
  
)

export default component.exports